<template>
  <section>
    <img
      v-for="location in locations"
      :key="location.name"
      :src="location.photo"
      :class="{ selected: selectedLocation == location }"
    />
    <ul v-if="locations.length > 1">
      <li
        v-for="location in locations"
        v-on:click="selectLocation(location)"
        :key="location.name"
        :class="{ selected: selectedLocation == location }"
      >
        {{ location.name }}
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  props: {
    locations: Array
  },
  data() {
    return {
      selectedLocation: this.locations.length > 0 ? this.locations[0] : null
    };
  },
  methods: {
    selectLocation: function(location) {
      this.selectedLocation = location;
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  position: relative;
  img {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: none;
    z-index: 1;

    &.selected {
      position: relative;
      z-index: 2;
      display: block;
    }
  }

  ul {
    position: absolute;
    bottom: 0;
    right: -70px;
    margin: 0;
    padding: 0;

    li {
      cursor: pointer;
      list-style: none;
      display: flex;
      align-items: center;
      margin-top: 13px;

      &:before {
        content: "";
        display: block;
        width: 15px;
        height: 15px;
        border: 2px solid #c4cb7a;
        border-radius: 100%;
        margin-right: 15px;
      }

      &.selected {
        &:before {
          background-color: #c4cb7a;
        }
        &:after {
          content: "";
          display: block;
          position: absolute;
          width: 10px;
          height: 2px;
          background-color: #c4cb7a;
          left: 17px;
        }
      }
    }
  }
}

@media (max-width: 1023px) {
  ul {
    position: static !important;
    display: flex !important;
    justify-content: center !important;

    li {
      margin: 0 10px;
      &:before {
        margin-right: 5px !important;
      }

      &.selected {
        &:after {
          content: none !important;
        }
      }
    }
  }
}
</style>
